const featureKeysBaseEndpoint = "/featurekeys/v1";
export const featureKeysEndpoints = {
    activateFeature: `${featureKeysBaseEndpoint}/Active`
};
